import { render, staticRenderFns } from "./Otomotif.vue?vue&type=template&id=db7cb0da&"
import script from "./Otomotif.vue?vue&type=script&lang=js&"
export * from "./Otomotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports